import React from 'react';

import { Typography, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
interface Props {
  url: string;
  name: string;
}
const imageUrl = '/images/icon-doc-dl.png';
const useStyles = makeStyles<Theme>((theme: Theme) => ({
  clampText: {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
  content: {
    backgroundColor: '#534E64',
    bottom: 0,
    padding: 8,
    width: '100%',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
  title: {
    cursor: 'pointer',
  },
  thumbnail: {
    backgroundImage: `url('${imageUrl}')`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: 160,
    position: 'relative',
    width: '100%',
    cursor: 'pointer',
  },
}));

const DocumentElement: React.FC<Props> = ({ url, name }) => {
  const { clampText, content, root, title, thumbnail } = useStyles();

  const handleClick = () => {
    window.open(url);
  };
  return (
    <div className={root}>
      <div className={thumbnail} onClick={handleClick} />
      <div className={content}>
        <Typography
          className={clsx(title, clampText)}
          variant={'body1'}
          onClick={handleClick}
          noWrap
        >
          {name}
        </Typography>
      </div>
    </div>
  );
};

export default DocumentElement;
